import { TrackingService } from './trackingService';
import { GaProvider } from './providers/ga-provider';
import { TrackingConfig } from '../types';

export const initTracking = (trackingConfig: TrackingConfig) => {
  window.eventsQueue = new TrackingService();
  window.eventsQueue.registerProvider(
    GaProvider.is,
    new GaProvider(trackingConfig)
  );
};

export const trackEvent = (name: GaProvider.EventName, category: GaProvider.EventCategory, label: string) => {
  window?.eventsQueue?.push({
    ga: {
      type: 'event',
      name: name,
      parameters: {
        event_category: category,
        event_label: label,
      },
    },
  });
};
